import React from "react";
import styled from "styled-components";
import {StyledReviewStore} from "../AddNewBranch/ReviewStore/ReviewStore.style";
import Banner from "../../../../../assets/Login/mcdBanner.png";
import mcdLogo from "../../../../../assets/Login/mcdLogo.svg";

const StyledStorePreview = styled(StyledReviewStore)`
    .info-wrap {
        margin-top: 20px;
        
        .info-item {
            display: flex;
            flex-direction: column;
            margin-bottom: 15px;
            
            strong {
                font-size: 14px;
                font-weight: 600;
                color: #1c1c1c;
                margin-bottom: 5px;
            }
            
            span {
                font-size: 14px;
                color: #666;
                line-height: 1.4;
            }
        }
    }
`;

const StorePreview = ({store, onClose}) => {


    const formatServiceTypes = () => {
        const services = [];
        if (store?.service_types?.delivery) services.push("Delivery");
        if (store?.service_types?.pickup) services.push("Pickup");
        return services.length > 0 ? services : ["No services available"];
    };

    return (
        <StyledStorePreview>

            {store?.cover_banner ? (
                <img src={store.cover_banner} alt="banner" className="banner" />
            ) : (
                <img src={Banner} alt="banner" className="banner" />
            )}
            
            <div className="details-wrap">
                {store?.store_logo ? (
                    <img src={store.store_logo} alt="logo" className="logo" />
                ) : (
                    <img src={mcdLogo} alt="logo" className="logo" />
                )}
                
                <strong className="title">{store?.name || store?.title || "Store Name"}</strong>
                <span className="location-wrap">{store?.address?.street_address || "Store Address"}</span>
                
                <ul className="category-wrap">
                    {formatServiceTypes().map((service, index) => (
                        <li key={index}>{service}</li>
                    ))}
                </ul>
                
                <div className="info-wrap">
                    
                    {store?.cuisines && store.cuisines.length > 0 && (
                        <div className="info-item">
                            <strong>Cuisines:</strong>
                            <span>{store.cuisines.map(cuisine => cuisine.name || cuisine).join(", ")}</span>
                        </div>
                    )}
                    
                    {store?.store_email && (
                        <div className="info-item">
                            <strong>Email:</strong>
                            <span>{store.store_email}</span>
                        </div>
                    )}
                </div>
            </div>
        </StyledStorePreview>
    );
};

export default StorePreview;
